import "../../../assets/RideSelectMenu.css";
import g from "clsx";
import n, { forwardRef as O, useState as P, useRef as ee, useEffect as p } from "react";
import { RideGlCheck as te } from "../graphic/glyph/components/RideGlCheck.js";
import { RideCheckbox as se } from "../checkbox/RideCheckbox.js";
import re from "lodash.uniqueid";
import { Popover as le } from "react-aria-components";
const ae = "_ul_1extw_85", ne = "_option_1extw_92", ce = "_input_1extw_98", ie = "_label_1extw_105", oe = "_text_1extw_108", de = "_disabled_1extw_150", ue = "_graphic_1extw_159", me = "_loading_1extw_188", _e = "_rotate_1extw_1", a = {
  "ride-select-menu": "_ride-select-menu_1extw_54",
  ul: ae,
  option: ne,
  input: ce,
  "glyph-checked": "_glyph-checked_1extw_99",
  label: ie,
  text: oe,
  "show-input": "_show-input_1extw_119",
  disabled: de,
  graphic: ue,
  "message-empty-options": "_message-empty-options_1extw_170",
  "loading-option": "_loading-option_1extw_188",
  loading: me,
  "fade-in": "_fade-in_1extw_1",
  "fade-out": "_fade-out_1extw_1",
  rotate: _e,
  "slide-in-up": "_slide-in-up_1extw_1",
  "slide-in-down": "_slide-in-down_1extw_1",
  "fill-center-out": "_fill-center-out_1extw_1"
}, we = O(
  ({
    className: q,
    id: I,
    loading: y,
    messageEmptyOptions: M,
    multiple: c,
    name: h,
    onClick: $,
    onOpenChange: l,
    isOpen: f = !1,
    options: b = [],
    onFilter: k,
    onOptionsSelected: _,
    onSelect: x,
    showCheckbox: S,
    triggerRef: i,
    value: N,
    placement: K = "bottom",
    shouldFlip: z = !0,
    ...G
  }, H) => {
    const [A, D] = P(
      () => b.map((e) => ({ ...e, checked: !1 }))
    ), [v, L] = P([]), T = re(":ride:"), u = ee(null);
    p(() => {
      F(N, b);
    }, [N, b]);
    const U = () => {
      var t;
      const e = (t = u == null ? void 0 : u.current) == null ? void 0 : t.querySelector("li:has(:checked)");
      e && e.scrollIntoView({ block: "nearest" });
    };
    p(() => {
      f && (U(), document.documentElement.style.setProperty("overflow", null), document.documentElement.style.setProperty("padding-right", null));
    }, [f]);
    const m = (e) => {
      const t = u == null ? void 0 : u.current, s = i == null ? void 0 : i.current;
      s && s.contains(e.target) || t && t.contains(e.target) || l == null || l(!1);
    };
    p(() => (window.addEventListener("mousedown", m), window.addEventListener("wheel", m), window.addEventListener("scroll", m), () => {
      window.removeEventListener("mousedown", m), window.removeEventListener("wheel", m), window.removeEventListener("scroll", m);
    }), [m]);
    const W = (e) => {
      if (!e) return !0;
      const t = Array.isArray(e);
      return c && t || !c && !t ? !0 : (console.warn(
        `RideSelectMenu: value must be ${c ? "an array" : "a string"} when using ${c ? "multiple" : "single"} selection.`
      ), !1);
    }, j = (e) => Array.isArray(e) ? e.map((t) => t.toString()) : e ? [e.toString()] : [], E = (e) => ({
      value: e.value,
      label: e.label,
      graphic: e.graphic
    }), B = (e, t) => {
      const s = [];
      return e.forEach((r) => {
        const d = t.find(
          (o) => o.value.toString() === r
        );
        d && s.push(E(d));
      }), s;
    }, F = (e, t = []) => {
      if (!W(e)) return;
      const s = j(e), r = t == null ? void 0 : t.map((o) => ({
        ...o,
        checked: s.includes(o.value.toString())
      }));
      D(r);
      const d = B(s, r);
      L(d), _ == null || _(d);
    }, J = () => g(q, a["ride-select-menu"]), Q = () => {
      var e;
      if (i != null && i.current)
        return {
          width: (e = i == null ? void 0 : i.current) == null ? void 0 : e.clientWidth
        };
    }, X = (e, t) => {
      const s = A.map((r) => r.value.toString() === e ? (x == null || x({ ...r, checked: t }), { ...r, checked: t }) : {
        ...r,
        checked: c ? !!(r != null && r.checked) : !1
      });
      D(s), Y(s, e, t);
    }, Y = (e, t, s) => {
      const r = v.find(
        (w) => w.value.toString() === t
      ), d = e.find((w) => w.value.toString() === t);
      let o = [];
      if (!c)
        o = [E(d)];
      else if (!s && r)
        o = v.filter(
          (w) => w.value.toString() !== t
        );
      else if (s && !r)
        o = [...v, E(d)];
      else
        return;
      L(o), _ == null || _(o, "onChange");
    }, V = (e) => {
      const { value: t, checked: s } = e.target;
      X(t, s);
    }, Z = (e) => c && S ? /* @__PURE__ */ n.createElement(
      se,
      {
        "aria-label": e.label,
        checked: e.checked,
        className: a["show-input"],
        value: e.value,
        name: h || `menu-option-${T}`,
        onChange: V,
        readOnly: !0,
        disabled: e.disabled,
        onClick: () => l == null ? void 0 : l(!!c)
      }
    ) : /* @__PURE__ */ n.createElement(
      "input",
      {
        checked: e.checked,
        className: a.input,
        type: c ? "checkbox" : "radio",
        value: e.value,
        name: h || `menu-option-${T}`,
        onChange: V,
        readOnly: !0,
        disabled: e.disabled,
        onClick: () => l == null ? void 0 : l(!!c)
      }
    ), C = (e) => {
      const t = e.target;
      e.code === "Tab" ? (e.preventDefault(), l == null || l(!1)) : e.code === "ArrowDown" && t.nextSibling ? (e.preventDefault(), t.nextSibling.focus()) : e.code === "ArrowUp" && t.previousSibling ? (e.preventDefault(), t.previousSibling.focus()) : (e.code === "Space" || e.code === "Enter") && (e.preventDefault(), t.querySelector("label").click());
    }, R = () => {
      const e = A.filter(
        (t) => k ? k(t) : !0
      );
      return e && e.length > 0 ? e.map((t) => /* @__PURE__ */ n.createElement(
        "li",
        {
          className: a.option,
          key: t.value,
          onKeyDown: C,
          role: "option",
          tabIndex: 0
        },
        /* @__PURE__ */ n.createElement(
          "label",
          {
            className: g(a.label, {
              [a.disabled]: t.disabled
            }),
            title: t.label
          },
          Z(t),
          t.graphic && /* @__PURE__ */ n.createElement("div", { className: a.graphic }, t.graphic),
          /* @__PURE__ */ n.createElement(
            "span",
            {
              className: a.text,
              onClick: (s) => s.stopPropagation()
            },
            t.label
          ),
          !S && /* @__PURE__ */ n.createElement(
            te,
            {
              size: "large",
              fill: "currentColor",
              className: a["glyph-checked"]
            }
          )
        )
      )) : /* @__PURE__ */ n.createElement("li", { role: "option", className: a.option }, /* @__PURE__ */ n.createElement("span", { className: a["message-empty-options"] }, M));
    };
    return p(() => {
      const e = document.querySelector('[data-testid="underlay"]');
      e && (e == null || e.addEventListener("touchstart", (t) => {
        t.preventDefault();
      }));
    }, [f]), /* @__PURE__ */ n.createElement(
      le,
      {
        ...G,
        className: J(),
        isOpen: f,
        onOpenChange: l,
        triggerRef: i,
        style: Q(),
        maxHeight: 252,
        offset: 4,
        containerPadding: 0,
        ref: u,
        placement: K,
        shouldFlip: z
      },
      /* @__PURE__ */ n.createElement(
        "ul",
        {
          id: I,
          className: a.ul,
          role: y ? "list" : "listbox",
          onClick: $,
          ref: H,
          "aria-label": "menu options"
        },
        y && Array(5).fill("").map((e, t) => /* @__PURE__ */ n.createElement("li", { key: t, className: a["loading-option"] }, e)),
        !y && R()
      )
    );
  }
);
we.displayName = "RideSelectMenu";
export {
  we as RideSelectMenu
};
